<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-room-service" icon-small title="لیست درخواست مشاوره ها" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-tabs v-model="activeTab" @change="tabChanged" background-color="transparent" centered slider-color="yellow">
						<v-tab :key="0">درخواست های در انتظار بررسی ({{ pendingConsultants.length }})</v-tab>
						<v-tab :key="1">همه درخواست ها ({{ countAll }})</v-tab>

						<v-tabs-items v-model="activeTab" touchless>
							<v-tab-item :key="0">
								<v-row>
									<v-col cols="12" lg="12">
										<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
									</v-col>
									<v-col cols="12">
										<v-data-table dense :headers="headers" :items="pendingConsultants" :items-per-page="500" :search="search" class="elevation-1">
											<template v-slot:item="row">
												<tr>
													<td>
														{{ row.item.name }}
													</td>
													<td>
														{{ row.item.phone }}
													</td>
													<td>
														<div style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
															{{ row.item.description }}
														</div>
													</td>
													<td class="text-center">
														{{ row.item.isSeen ? 'بلی' : 'خیر' }}
													</td>
													<td class="text-center">
														{{ row.item.saveDate_Persian.date }} {{ row.item.saveDate_Persian.time }}
													</td>
													<td style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
														{{ row.item.callResult }}
													</td>
													<td class="text-center">
														<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
															<v-icon dark>
																mdi-square-edit-outline
															</v-icon>
														</v-btn>
														<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
															<v-icon dark>
																mdi-trash-can-outline
															</v-icon>
														</v-btn>
													</td>
												</tr>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-tab-item>
							<v-tab-item :key="1">
								<v-row>
									<v-col cols="12" lg="12">
										<v-text-field v-model="search2" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
									</v-col>
									<v-col cols="12">
										<v-data-table dense :headers="headers" :items="allConsultants" :items-per-page="500" :search="search2" class="elevation-1">
											<template v-slot:item="row">
												<tr>
													<td>
														{{ row.item.name }}
													</td>
													<td>
														{{ row.item.phone }}
													</td>
													<td>
														<div style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
															{{ row.item.description }}
														</div>
													</td>
													<td class="text-center">
														{{ row.item.isSeen ? 'بلی' : 'خیر' }}
													</td>
													<td class="text-center">
														{{ row.item.saveDate_Persian.date }} {{ row.item.saveDate_Persian.time }}
													</td>
													<td style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
														{{ row.item.callResult }}
													</td>
													<td class="text-center">
														<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
															<v-icon dark>
																mdi-square-edit-outline
															</v-icon>
														</v-btn>
														<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
															<v-icon dark>
																mdi-trash-can-outline
															</v-icon>
														</v-btn>
													</td>
												</tr>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-tab-item>

						</v-tabs-items>
					</v-tabs>

				</v-col>
			</v-row>
			<v-dialog v-model="dialog" scrollable persistent max-width="800px">
				<v-card>
					<v-card-title>
						<span class="headline">اطلاعات درخواست مشاوره</span>
						<v-spacer />
						<v-btn @click="dialog = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-form ref="form" class="mx-2" lazy-validation>
							<v-container>
								<v-row>
									<v-col cols="12" md="4">
										<v-text-field v-model="saveDate_Persian" label="تاریخ ثبت درخواست" :disabled="true" />
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field v-model="localData.name" label="نام" :disabled="true" />
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field v-model="localData.phone" label="شماره تماس" :disabled="true" />
									</v-col>
									<v-col cols="12">
										<v-textarea v-model="localData.description" outlined :error-messages="errorMessages" label="شرح درخواست" :disabled="true" />
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-textarea v-model="localData.callResult" outlined :error-messages="errorMessages" label="پیگیری تماس" />
									</v-col>
								</v-row>
							</v-container>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn color="success" dark @click="submit(true)" v-if="!localData.isSeen">
							درخواست پیگیری شد و از لیست در انتظار خارج شود
						</v-btn>
						<v-btn color="blue" dark @click="submit(false)" v-if="!localData.isSeen">
							ذخیره بدون خروج از لیست
						</v-btn>
						<v-btn color="blue" dark @click="submit(true)" v-if="localData.isSeen">
							ذخیره
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'

export default {
	name: 'MembersView',
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
	},
	data() {
		return {
			saveDate_Persian: '',
			activeTab: 0,
			countAll: 0,
			allConsultantsFetched: false,
			pendingConsultantsFetched: false,
			errorMessages: '',
			datePickerValidatioin: '',
			localData: {},
			dialog: false,
			search: '',
			search2: '',
			loading: false,
			headers: [
				{
					text: 'نام',
					align: 'start',
					sortable: true,
					value: 'name',
					width: 150
				}, {
					text: 'شماره تماس',
					align: 'start',
					sortable: true,
					value: 'phone',
					width: 150
				}, {
					text: 'شرح درخواست',
					align: 'start',
					sortable: true,
					value: 'description',
				}, {
					text: 'دیده شده',
					align: 'center',
					sortable: true,
					value: 'isSeen',
				}, {
					text: 'تاریخ ثبت درخواست',
					align: 'start',
					sortable: true,
					value: 'saveDate_Persian',
				}, {
					text: 'نتیجه تماس',
					align: 'center',
					sortable: true,
					value: 'callResult',
					width: 200
				}, {
					text: 'عملیات ها',
					align: 'center',
					sortable: false,
					width: 150,
				},
			],
			allConsultants: [],
			pendingConsultants: [],
		}
	},
	mounted() {
		this.tabChanged(0)
	},
	methods: {
		loadData(all) {
			this.loading = true
			let data = all || false
			api.get('superadmin/Consultant/list/' + data, null)
				.then(
					response => {
						if (all) {
							this.allConsultants = response.consultants
							this.countAll = response.countAll
							this.allConsultantsFetched = true
						} else {
							this.pendingConsultants = response.consultants
							this.countAll = response.countAll
							this.pendingConsultantsFetched = true
						}
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.loading = false })
		},
		edit(item) {
			api.get('superadmin/Consultant/get/' + item.id, null)
				.then(
					response => {
						this.localData = response
						this.saveDate_Persian = response.saveDate_Persian.date + ' ' + response.saveDate_Persian.time
						this.dialog = true
					})
				.catch(err => {
					toast.error(err.message)
				})
		},
		submit(isSeen) {
			if (!this.$refs.form.validate()) { return }

			let data = { ...this.localData }
			data.isSeen = isSeen
			api.post('superadmin/Consultant/' + (this.localData.id === 0 ? 'create' : 'edit'), data)
				.then(
					response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.loadData(this.activeTab == 1)
						this.dialog = false
					})
				.catch(err => {
					toast.error(err.message)
				})
		},
		async remove(item) {
			if (!item) { return }

			if (await this.$refs.confirm.open(
				'توجه',
				'آیا از حذف این آیتم مطمئن هستید؟',
			)) {
				api.post('superadmin/Consultant/delete/' + item.id)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.allConsultantsFetched = false
							this.pendingConsultantsFetched = false
							this.pendingConsultants = this.activeTab == 1 ? [] : this.pendingConsultants
							this.allConsultants = this.activeTab == 0 ? [] : this.allConsultants
							this.loadData(this.activeTab == 1)
						})
					.catch(err => {
						toast.error(err.message)
					})
			}
		},
		tabChanged(tab) {
			if (tab == 1 && !this.allConsultantsFetched)
				this.loadData(true)
			else if (tab == 0 && !this.pendingConsultantsFetched)
				this.loadData(false)
		}
	},
}
</script>
<style></style>
